<template>
    <!-- Banner de incio -->
    <div class="bannerHome">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <p>Apr 14, 2024</p>
                <h1>
                    Entrenamiento <br />
                    Carrera de Obstáculos
                </h1>
            </div>
            <div class="colImg col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FJiloMagico.jpg?alt=media&token=2e2974b6-06ff-45e5-aa9f-6a6de2ef777a"
                    alt="Logo Banner" class="imgHome2 img-fluid" />
            </div>
        </div>
    </div>

    <!-- Contenido de la pagina principal -->
    <main class="container mt-3 text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 mol-md-12 col-sm-12 col-xs-12">
                    <div class="card cardInfo shadow rounded-2" id="registro">
                        <img class="logoCard img-fluid"
                            src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FLogoCarrera2.jpg?alt=media&token=cae77b5a-3123-4a44-96d9-f50e43617ba6"
                            alt="Logo" />
                        <div class="card-body">
                            <h4 class="card-title">Entrenamiento con Obstáculos</h4>
                            <h5 class="card-subtitle mb-3">Canalejas</h5>

                            <ul class="list-group">
                                <li class="list-group-item">
                                    <strong>Fecha:</strong> Domingo, 14 de abril
                                </li>
                                <li class="list-group-item">
                                    <strong>Lugar:</strong> Parque El Llano - Canalejas
                                </li>
                                <li class="list-group-item">
                                    <strong>Hora de Inicio:</strong> 8:00 AM
                                </li>
                                <li class="list-group-item">
                                    <strong>Distancias:</strong> 5 y 10 km
                                </li>
                            </ul>
                            <br>
                            <a href="#" class="btnInscripcion mt-4">
                                Registro Finalizado
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 mt-5">
                    <img class="imgBanner img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FLogoPrincipal.png?alt=media&token=7c05bd30-7ab0-475d-83aa-179d4646ac60"
                        alt="Logo" />

                    <h2 class="mt-2">¡Únete a nuestra carrera de entrenamiento!</h2>
                    <p>
                        Únete a nosotros este <b>14 de abril de 2024</b> para un
                        entrenamiento especial. ¡No importa tu nivel de experiencia!
                        Mejora tus habilidades, desafia tus límites y prepárate para el
                        desafio final.
                    </p>
                </div>
            </div>

            <!-- Segundo apartado -->
            <br />
            <div class="sp2 mt-3 text-center" id="informacion">
                <h1>5 y 10km con Obstaculos</h1>

                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <div class="text-center mb-4">
                                    <i class="fas fa-hand-fist fa-4x text-danger"></i>
                                </div>
                                <h3 class="card-title text-center mb-4">
                                    Tipos de Obstáculos
                                </h3>
                                <ul class="list-unstyled">
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Arrastre
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Muro
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Fosa de
                                        Agua
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Y muchos
                                        más
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <div class="text-center mb-4">
                                    <i class="fas fa-location-dot fa-4x text-danger"></i>
                                </div>
                                <h3 class="card-title text-center mb-3">Salida y Meta:</h3>
                                <h4 class="card-subtitle text-center mb-4">
                                    Parque El Llano Bosque de Canalejas
                                </h4>
                                <p class="card-text text-center mb-0">
                                    Búscalo en Google Maps como:<br />
                                    <b>Parque El Llano Canalejas</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <img src="@/assets/images/carrera2023_1.jpg" class="imgCarrusel mx-auto rounded-2 mt-4 img-fluid">

                <div class="mt-4 text-center">
                    <h3 class="mb-4">
                        Ruta diseñada para todas las categorías. ¡Escoge tu distancia y
                        listo!
                    </h3>
                    <h4 class="mb-5">
                        Menores de edad deben llevar autorización firmada
                    </h4>
                </div>

                <div class="alert alert-light text-center mx-auto shadow" role="alert" style="max-width: 400px">
                    ¿Dudas y preguntas? Llámanos al <b>5540861907</b>
                </div>

                <img src="@/assets/images/bannerEntrenamiento_2024.jpg" class="img-fluid rounded-2 mx-auto" width="620"
                    height="400">
            </div>

            <!--Tercer apartado-->
            <br />
            <div class="sp3">
                <h1>Costos y Formas de pago</h1>

                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <h5 class="card-title text-center mb-4"> Precios de Inscripción </h5>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Del 12 de febrero al 12 de marzo:</span>
                                        <span><b>$100</b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Del 13 de marzo al 12 de abril:</span>
                                        <span><b>$150</b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Día del evento:</span>
                                        <span><b>$200</b></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <h5 class="card-title text-center mb-4">Formas de Pago</h5>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">
                                        <p class="mb-1">Transferencia electrónica o depósito:</p>
                                        <b>BBVA: 4152314110754507</b>
                                        <p class="mb-0">Titular: Carrera de Obstáculos</p>
                                        <p class="mb-0">Motivo: Pago de carrera</p>
                                    </li>
                                    <li class="list-group-item">
                                        <p class="mb-1">Transferencia electrónica o depósito:</p>
                                        <b>OXXO: 646420146403035509</b> Stp o Spin
                                    </li>
                                    <li class="list-group-item">
                                        <p class="mb-1">Envía tu comprobante de pago al:</p>
                                        <strong>5540861907</strong>
                                        <p class="mb-0">
                                            Incluye tu Nombre Completo, Número de Teléfono, la
                                            Distancia Elegida y Listo.
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="sp4 container-fluid mt-4">
                <h1>Carrea de Obstáculos 2023</h1>
                <!--Carrusel de imagenes-->
                <div id="carouselExampleAutoplaying" class="carousel slide mt-3" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/carrera%202023%2F1.png?alt=media&token=9b86b22e-6cb9-4f2b-bc65-26f4ecafb4f1"
                                alt="Banner 1" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                                width="700" height="400" />
                        </div>
                        <div class="carousel-item">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/carrera%202023%2F2.png?alt=media&token=cf6ce0cb-ea27-4d83-bd42-e0f586a18f57"
                                alt="Banner 2" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                                width="700" height="400" />
                        </div>
                        <div class="carousel-item">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/carrera%202023%2F3.png?alt=media&token=3edc0b6c-bac5-4dcf-941a-70a48331a308"
                                alt="Banner 3" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                                width="700" height="400" />
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import '@fortawesome/fontawesome-free/css/all.css'
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  document.body.style.backgroundColor = '#F6F6F6'
})

onUnmounted(() => {
  document.body.style.backgroundColor = '#F6F1EC'
})
</script>

<style scoped>
@font-face {
    font-family: "FuentePersonalizada";
    src: url('../assets/fonts/GreenKingsWood-Regular1.otf') format('opentype');
}

@font-face {
    font-family: 'FuerntePerso2';
    src: url('../assets/fonts/Roboto-Regular.ttf') format('opentype');
}

#navModified {
    background: #CF1019;
}

#navModified .nav-link {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 25px;
}

.bannerHome {
    background-color: #303030;
    padding: 16px;
}

.bannerHome p {
    color: #fff;
    font-size: 23px;
    margin: 0 0 0 0;
}

.bannerHome h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 5rem;
    color: #fff;
}

.bannerHome img {
    margin: 0 auto;
    width: 190px;
    height: 190px;
}

.bannerHome .imgHome1,
.bannerHome .imgHome2 {
    border-radius: 120px;
}

.cardInfo {
    padding: 10px;
}

.logoCard {
    border: 1 px solid #8d8d8d;
    border-radius: 120px;
    box-shadow: 0 1px 2px #ccc;
    height: 230px;
    margin: 0 auto;
    width: 230px;
}

.imgBanner {
    margin: 0 auto;
    width: 230px;
    height: 230px;
}

.btnInscripcion {
    width: 100%;
    text-decoration: none;
    color: #8d8d8d;
    font-style: initial;
    font-size: 30px;
    font-family: 'FuentePersonalizada', Arial, sans-serif;
    padding: 10px;
}

.sp2 .row .cols {
    padding: 10px;
}

.sp2 h1 {
    font-family: 'FuentePersonalizada', Arial, sans-serif;
    font-size: 60px;
}

.sp2 .card {
    height: 350px;
}

.sp2 .alert {
    width: 60%;
    background-color: #ff464c;
    color: #fff;
}

.sp3 .row .cols {
    padding: 10px;
}

.sp3 h1 {
    font-family: 'FuentePersonalizada', Arial, sans-serif;
    font-size: 60px;
    text-align: center;
}

.sp3 .card {
    text-align: center;
    font-size: 20px;
}

.sp3 .card b {
    color: green;
}

.sp3 .info {
    font-size: 15px;
}

.carousel {
    height: 400px;
}

.imgCarrusel {
    width: 620px;
    height: 300px;
}

.sp4 h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    text-align: center;
    font-size: 60px;
}
</style>
